
'use strict';


/**
 * 
 * 
 * @param string answer
 * @param string destId
 * @param array srcIds
 * @return void
 */
var Rule = function ( answer, destId, srcIds ) {
  
  var destAnswer = answer;
  var destId = destId;
  var sourceIds = srcIds;
  
  return {
    
    /**
     * -  
     * 
     * @return array
     */
    getDestAnswerValue : function(){
      return destAnswer;
    },


    /**
     * -  
     * 
     * @return string
     */
    getDestId : function(){
      return destId;
    },


    /**
     * -  
     * 
     * @return array
     */
    getSourceIds : function(){
      return sourceIds;
    },


    /**
     * -  
     * 
     * @param array answerId
     * @return boolean
     */
    answerPresentInSourceIds : function( answerIds ){

      for( var k in answerIds ){
        
        var answerId = answerIds[ k ];

        for( var i in sourceIds ){
          if( answerId == sourceIds[ i ] ){
            return sourceIds[ i ];
          }
        }
      }

      return '';
    }

    
  };

};

export default Rule;